import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface BroadcastMessage {
  type: string;
  payload?: any;
}

@Injectable({ providedIn: 'root' })
export class BroadcastService implements OnDestroy {
  private channel: BroadcastChannel;
  private messageSubject = new Subject<any>();
  public messages$: Observable<any> = this.messageSubject.asObservable();

  constructor() {
    this.channel = new BroadcastChannel('topo-broadcast-channel');
    this.channel.onmessage = event => {
      this.messageSubject.next(event.data);
    };
  }

  ngOnDestroy(): void {
    this.channel.close();
    this.messageSubject.complete();
  }

  sendMessage(message: BroadcastMessage): void {
    this.channel.postMessage(message);
  }

  listen(type: string): Observable<BroadcastMessage> {
    return this.messages$.pipe(
      filter(msg => msg.type === type),
      map(msg => msg?.payload ?? null)
    );
  }
}
